import { Injectable } from '@angular/core';
import { ShipmentsEntitiesState } from './shipments/shipments-entities.state';
import OrdersEntitiesState from './orders/orders-entities.state';
import { IIdMap, OrdersFiltersModel } from '../_models/self-ship/orders/orders-filters.model';
import * as _ from 'lodash';
import OrdersFiltersState from './orders/orders-filters/orders-filters.state';
import { DataAction, StateRepository } from '@angular-ru/ngxs/decorators';
import { State } from '@ngxs/store';
import { NgxsDataRepository } from '@angular-ru/ngxs/repositories';
import { ProcessingStatus } from '../_entities/orders/processing-statuses/processing-status';
import { IN_PROCESS_FILTERS, SELFSHIP_ORDER_FILTERS } from '../_entities/orders/processing-statuses/order-filter-status';


@StateRepository()
@State({
    name: 'intermediary',
    defaults: {}
})
@Injectable()
export class IntermediaryState extends NgxsDataRepository<{}> {

    constructor(
        public shipmentEntitiesState: ShipmentsEntitiesState,
        public ordersEntitiesState: OrdersEntitiesState,
        public ordersFiltersState: OrdersFiltersState
    ) {
        super();
    }

    // Getter
    get filteredOrderEntities() {
        return this.ordersEntitiesState.filteredEntityMap;
    }

    // Methods
    @DataAction()
    public setOrderFilters(filterState: OrdersFiltersModel) {
        const originalState = _.cloneDeep(this.ordersFiltersState.snapshot);
        const dateHasChanged = originalState?.dateRange?.fromDate?.toString() !== filterState?.dateRange?.fromDate?.toString() ||
            originalState?.dateRange?.toDate?.toString() !== filterState?.dateRange?.toDate?.toString();
        const customerChange = originalState?.customer !== filterState.customer;

        this.ordersFiltersState.setState(_.assignIn(new OrdersFiltersModel(), filterState));
        if (dateHasChanged || customerChange) {
            this.ordersEntitiesState.loadCountThenOrders();
        }
    }

    @DataAction()
    public toggleAllFilterStatus() {
        const currentVal = this.ordersFiltersState.snapshot.orderStatuses;
        if (currentVal.length === SELFSHIP_ORDER_FILTERS.length) {
            this.ordersFiltersState.patchState({
                orderStatuses: []
            });
        } else {
            this.ordersFiltersState.patchState({
                orderStatuses: SELFSHIP_ORDER_FILTERS
            });
        }
    }

    @DataAction()
    public toggleOrderStatus(status: ProcessingStatus, inProcessStatus: boolean = false) {
        this.ordersFiltersState.patchState({
            orderStatuses: !!inProcessStatus
                ? IN_PROCESS_FILTERS
                : [status]
        });
    }

    @DataAction()
    public toggleSelectAllFilteredOrderEntities() {
        let filteredIdsMap: IIdMap = {};
        if (Object.keys(this.ordersFiltersState.snapshot.selected).length !== this.ordersEntitiesState.filteredEntityMap.count) {
            filteredIdsMap = Object.keys(this.ordersEntitiesState.filteredEntityMap.entities)
                .reduce((results, id) => {
                    results[id] = true;
                    return results;
                }, {});
        }
        this.ordersFiltersState.patchState({
            selected: filteredIdsMap
        });
    }
}
